import React, { useState, useRef } from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { DURATION } from "../data/globalStyles"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginBottom: "2rem",
    maxWidth: "350px",
  },
  linkContainer: {
    display: "flex",
  },
  link: {
    display: "flex",
    justifyContent: "flex-start",
    padding: ".5rem 1rem",
    border: `2px solid ${colors.orange}`,
    color: colors.black,
    cursor: "text",
    fontFamily: "Jost",
    fontWeight: "300",
    fontSize: "calc(12px + (14 - 10) * ((100vw - 300px) / (1600 - 300)))",
    textDecoration: "none",
    width: "200px",
  },
  label: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: ".5rem 1rem",
    textTransform: "uppercase",
    border: `2px solid ${colors.orange}`,
    backgroundColor: colors.orange,
    color: colors.white,
    transition: `background-color ${DURATION} ease-in-out, color ${DURATION} ease-in-out`,
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "calc(10px + (13 - 10) * ((100vw - 300px) / (1600 - 300)))",
    textDecoration: "none",
    textAlign: "center",
    "&:hover": {
      backgroundColor: colors.white,
      color: colors.black,
    },
    "@media only screen and (max-width: 810px)": {
      flex: "none",
    },
  },
  text: {
    margin: "0 15px",
  },
}

const CopyToClipboard = ({ classes, url }) => {
  const ref = useRef(null)

  const COPY_STATES = ["", "success", "error"]
  const [status, setStatus] = useState(COPY_STATES[0])

  const fallbackCopyTextToClipboard = () => {
    const urlElement = ref.current
    urlElement.select()

    try {
      var successful = document.execCommand("copy")
      if (successful) {
        setStatus(COPY_STATES[1])
      } else {
        setStatus(COPY_STATES[2])
      }
    } catch (err) {
      setStatus(COPY_STATES[2])
    }
  }

  const copyUrlToClipboard = (url) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard()
      return
    }
    navigator.clipboard.writeText(url).then(
      () => {
        setStatus(COPY_STATES[1])
      },
      () => {
        setStatus(COPY_STATES[2])
      }
    )

    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-tgivingMenu-copyURL",
        "gtm.elementUrl": url,
      })
    }
  }

  return (
    <div className={classes.container}>
      <span className={classes.label}>
        {status === COPY_STATES[1]
          ? "Link to your custom menu has been copied successfully!"
          : status === COPY_STATES[2]
          ? "Something went wrong! Try again or manually copy the URL."
          : "Bookmark or copy your custom menu URL to share with family and friends."}
      </span>
      <div className={classes.linkContainer}>
        {/* <div className={classes.link}>{url}</div> */}
        <input
          ref={ref}
          className={classes.link}
          type="text"
          value={url}
          autoComplete="off"
          readOnly
        />
        <button
          className={classes.button}
          onClick={() => copyUrlToClipboard(url)}>
          Copy URL
        </button>
      </div>
    </div>
  )
}

export default withStyles(styles)(CopyToClipboard)
